import React, { useEffect, useState } from 'react'
import { createRoot } from "react-dom/client"
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom"
import { ThemeProvider as MaterialThemeProvider } from '@material-ui/core/styles'
import { customTheme } from './styling'
import './index.css'
import { Provider } from 'react-redux'
import { persistor, rootStore } from './redux/store'
import { PersistGate } from 'redux-persist/integration/react'

// Components
import NotFound from './404'
import Dashboard from './pages/dashboard'
import Products from './pages/products'
import Clients from './pages/clients'
import Agents from './pages/agents'
import Login from './pages/auth/login'
import Settings from './pages/settings'
import ResetPassword from './pages/auth/reset-password'
import PrivateRoute from './components/private-route'
import SnackBar from './components/snackbar'
import Notifications from './pages/notifications'
import { getRoleUserIdFromToken } from './utils'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

const rootElement = document.getElementById("root")
const root = createRoot(rootElement)


const AppRouter = () => {
  const location = useLocation()
  const [roleUserId, setRoleUserId] = useState(getRoleUserIdFromToken())
  
  useEffect(() => {
    setRoleUserId(getRoleUserIdFromToken())
  }, [location.pathname])


  return <Switch>
    <Route exact path="/">
      <Redirect to={'/dashboard'} />
    </Route>
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/login" component={Login} />
    <Route exact path="/dashboard" component={PrivateRoute(Dashboard)} />
    <Route exact path="/products" component={PrivateRoute(Products)} />
    <Route exact path="/clients" component={PrivateRoute(Clients)} />
    <Route exact path="/notifications" component={PrivateRoute(Notifications)} />
    {roleUserId === 1 && <Route exact path="/agents" component={PrivateRoute(Agents)} />}
    <Route exact path="/admin" component={PrivateRoute(Settings)} />
    <Route component={PrivateRoute(NotFound)} />
  </Switch>
}
root.render(
  <Provider store={rootStore}>
    <PersistGate loading={null} persistor={persistor}>
      <MaterialThemeProvider theme={customTheme}>
        <SnackBar.Provider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </SnackBar.Provider>
      </MaterialThemeProvider>
      </PersistGate >
  </Provider>
  

)

